module.exports = __webpack_public_path__ + "img/chad.ec54a73c.svg";